import { AnyObject } from 'types';
import { Node } from 'slate';

export type FilterNodes = (filterFunction: FilterFunction) => CustomNode[];

type CustomNode = Node & AnyObject;

type FilterFunction = (node: CustomNode) => boolean;

export default function filterNodes(editor): FilterNodes {
  return function (filterFunction: FilterFunction): CustomNode[] {
    return editor.children
      .flatMap((children) => children.children)
      .filter(filterFunction);
  };
}
